var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-loader"},[(_vm.allDataLoaded)?_c('div',{staticClass:"scrool-loader-all ms-help"},[_vm._v("\n    Все данные загружены\n  ")]):_c('inline-loader',{attrs:{"loading":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }